"use strict";

import Vue from "vue";
import axios from "axios";
// loading 配置文件

axios.defaults.headers.post["Content-Type"] = "application/json";

// api 配置
let config = {
    // baseURL: process.env.baseURL || process.env.apiUrl || "",
    baseURL: "",
    timeout: '', // Timeout
    withCredentials: true
};
 // withCredentials: true // Check cross-site Access-Control
const _axios = axios.create(config);

_axios.interceptors.request.use(
    function(config) {
        // 在发送请求之前做些什么
        // if (localStorage.getItem('token')) {
        //     //如果有token就将token添加至请求头
            // config.headers['X-Access-Token'] = localStorage.getItem('token')
        // }
        // loadingInstance = Loading.service(options);
        // console.log('request', config)
        // Do something before request is sent

        return config;
    },
    function(error) {
        // console.log('request=error', error)
        // Do something with request error
        return Promise.reject(error);
    }

);

// Add a response interceptor
_axios.interceptors.response.use(
    function(response) {
        // Do something with response data
        // console.log('response', response)
        // window.alert(response)
        // loadingInstance.close()
        return response.data;
    },
    function(error) {
        // Do something with response error
        // loadingInstance.close()
        // if (error && error.response) {
        //     switch (error.response.status) {
        //         case 400:
        //             error.message = "请求错误(400)";
        //             break;
        //         case 401:
        //             error.message = "登录失效，请重新登录";
        //             break;
        //         case 403:
        //             error.message = "拒绝访问(403)";
        //             break;
        //         case 404:
        //             error.message = "请求出错(404)";
        //             break;
        //         case 408:
        //             error.message = "请求超时(408)";
        //             break;
        //         case 500:
        //             error.message = "服务器错误(500)";
        //             break;
        //         case 501:
        //             error.message = "服务未实现(501)";
        //             break;
        //         case 502:
        //             error.message = "网络错误(502)";
        //             break;
        //         case 503:
        //             error.message = "服务不可用(503)";
        //             break;
        //         case 504:
        //             error.message = "网络超时(504)";
        //             break;
        //         case 505:
        //             error.message = "HTTP版本不受支持(505)";
        //             break;
        //         default:
        //             error.message = `连接出错(${error.response.status})!`;
        //     }
        // } else {
        //     error.message = "连接服务器失败!";
        // }
        return Promise.reject(error);
    }
);

Plugin.install = function(Vue, options) {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios;
            }
        },
        $axios: {
            get() {
                return _axios;
            }
        }
    });
};

Vue.use(Plugin);

export default Plugin;